import { sendGet, sendPost } from "./axios";

export const getKoboSyncStatus = () => sendGet("/dm/monitoring/kobo-sync");
export const getKoboFailures = (limit = 50) =>
  sendGet(`/dm/monitoring/kobo-failures?limit=${limit}`);
export const postKoboReconcile = (hours = 72) =>
  sendPost("/dm/monitoring/kobo-reconcile", { hours });
export const getUserActivity = () => sendGet("/dm/monitoring/user-activity");
export const getKoboHookFailures = (limit = 50, refresh = false) =>
  sendGet(`/dm/monitoring/kobo-hook-failures?limit=${limit}${refresh ? '&refresh=1' : ''}`);
export const postKoboHookRetry = (form_uid, hook_uid, log_uid) =>
  sendPost("/dm/monitoring/kobo-hook-retry", { form_uid, hook_uid, log_uid });
